import { CheckCircleIcon } from "@phosphor-icons/react/ssr";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import ValueComparisonTable from "~/componentsDS/ValueComparisonTable";

import {
    OESTRA_ALTERNATIVES_COMPARISON_ROWS,
    OESTRA_TOTAL_VALUE_ROWS,
} from "./comparisonData";

const OESTRA_HIGHLIGHTS = [
    "One product",
    "Correct hormone ratios",
    "Systemic, whole-body support",
    "No patch juggling, pill stacking, or fragmented care",
];

const OestraTotalValueContent = () => (
    <div className="text-primary500">
        <Paragraph size="lg" className="mb-[32px]">
            Oestra<sup>®</sup> replaces what is often prescribed as multiple, disconnected hormone products —
            and delivers them systemically through one highly bioavailable route.
        </Paragraph>

        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-2 max-md:max-w-[270px] max-md:font-medium">
            What women often need to replicate Oestra<sup>®</sup>
        </Paragraph>        
        
        <Paragraph size="lg" className="mb-4">
            To achieve similar support using standard prescriptions, many women are prescribed:
        </Paragraph>

        <ValueComparisonTable rows={OESTRA_ALTERNATIVES_COMPARISON_ROWS} className="mb-[32px]" />

        <Paragraph size="xl" sizes={{ md: "2xl" }} weight="500" className="mb-4">
            Oestra<sup>®</sup> Total Value
        </Paragraph>

        <ValueComparisonTable rows={OESTRA_TOTAL_VALUE_ROWS} />

        <ul className="mt-4 flex flex-col gap-4">
            {OESTRA_HIGHLIGHTS.map((item) => (
                <li key={item} className="flex items-start gap-1">
                    <CheckCircleIcon size={20} weight="fill" className="shrink-0 text-primary500" />
                    <Paragraph size="lg" className="max-md:max-w-[255px]">{item}</Paragraph>
                </li>
            ))}
        </ul>
    </div>
);

export default OestraTotalValueContent;
